import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Box,
} from "@mui/material";

const AlamatPage = () => {
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  // Fetch provinces
  useEffect(() => {
    const fetchProvinces = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/propinsi`);
        if (!response.ok) {
          const text = await response.text();
          console.error("Province error:", response.status, text);
          return;
        }

        const json = await response.json();
        setProvinces(json || []);
      } catch (error) {
        console.error("Error fetching provinces:", error);
      }
    };

    fetchProvinces();
  }, []);

  // Fetch cities
  useEffect(() => {
    const fetchCities = async () => {
      if (!selectedProvince) return;

      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/kota`);
        if (!response.ok) {
          const text = await response.text();
          console.error("City fetch error:", response.status, text);
          return;
        }

        const json = await response.json();
        const filteredCities = json.filter((city) => city.propinsiId === parseInt(selectedProvince));
        setCities(filteredCities || []);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    fetchCities();
  }, [selectedProvince]);

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Pilih Provinsi & Kota
      </Typography>

      {/* Province Select */}
      <FormControl fullWidth margin="normal">
        <InputLabel id="province-label">Provinsi</InputLabel>
        <Select
          labelId="province-label"
          id="province-select"
          value={selectedProvince}
          label="Provinsi"
          onChange={(e) => {
            setSelectedProvince(e.target.value);
            setSelectedCity("");
          }}
        >
          {Array.isArray(provinces) &&
            provinces.map((province) => (
              <MenuItem key={province.id} value={province.id}>
                {province.nama}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      {/* City Select */}
      <FormControl fullWidth margin="normal" disabled={!selectedProvince}>
        <InputLabel id="city-label">Kota</InputLabel>
        <Select
          labelId="city-label"
          id="city-select"
          value={selectedCity}
          label="Kota"
          onChange={(e) => setSelectedCity(e.target.value)}
        >
          {Array.isArray(cities) &&
            cities.map((city) => (
              <MenuItem key={city.id} value={city.nama}>
                {city.nama}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      {/* Result Display */}
      {selectedProvince && selectedCity && (
        <Typography variant="body1" sx={{ mt: 2 }}>
          Lokasi dipilih: <strong>{selectedCity}</strong> -{" "}
          <strong>
            {
              provinces.find((p) => p.id === parseInt(selectedProvince))
                ?.nama
            }
          </strong>
        </Typography>
      )}
    </Box>
  );
};

export default AlamatPage;
